module.exports = __webpack_public_path__ + "img/full_right_angle_corner_arrow_line.b8aea976.svg";